<template>
  <div>
    <header class="homapt-header" v-bind:style="backgroundImage">
      <div class="dark-overlay">
        <div class="container-fluid">
          <div class="row header-row h-100">
            <div class="col-md-6 offset-md-4 my-auto">
              <h1 class="title">Save TIME and Money</h1>
              <br>
              <h3 class="title">Let HomApt take the stress out of the home ownership process.</h3>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="container">
      <div class="row example-row">
        <div class="col my-auto text-center">
          <h3>Example: $250,000 offer</h3>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row example-row price-difference-row">
        <div class="col my-auto text-center">
          <h3>Price Difference</h3>
        </div>
      </div>
    </div>
    <div class="homapt-table container">
      <div class="row homapt-table-row">
        <div class="col">
        </div>
        <div class="col text-center my-auto center-column">
          <p class="table-text"><b>HomApt</b></p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text"><b>Traditional</b></p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto">
          <p class="table-text">Seller's Broker</p>
        </div>
        <div class="col text-center my-auto center-column">
          <p class="table-text">$3,750 (1.5%*)</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">$7,500 (3.0%)</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto">
          <p class="table-text">Buyer's Broker</p>
        </div>
        <div class="col text-center my-auto center-column">
          <p class="table-text">$7,500 (3.0%)</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">$7,500 (3.0%)</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto">
          <p class="table-text">Additional Broker Fees</p>
        </div>
        <div class="col text-center my-auto center-column">
          <p class="table-text">$0</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">$200-500</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto">
          <p class="table-text">Title Charges</p>
        </div>
        <div class="col text-center my-auto center-column">
          <p class="table-text">$2,500</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">$2,500</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto">
          <p class="table-text">Closing Agent</p>
        </div>
        <div class="col text-center my-auto center-column">
          <p class="table-text">$2,500</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">$2,500</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto">
          <p class="table-text">Repairs Needed to Sell</p>
        </div>
        <div class="col text-center my-auto center-column">
          <p class="table-text">TBD</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">TBD</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto">
          <p class="table-text"><strong>Total</strong></p>
        </div>
        <div class="col text-center my-auto center-column">
          <p class="table-text"><strong>$233,750</strong></p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text"><strong>$229,800</strong></p>
        </div>
      </div>
      <div class="row text-center">
        <div class="col conclusion">
          <h3 class="table-conclusion">Save $3,750 and more on your next house!</h3>
        </div>
      </div>
      <div class="row text-left">
        <div class="col">
          <p class="table-text">*Minimum commission rates apply. See commission details for more information.</p>
          <p class="table-text">**Fees are estimated based on 2018 Minnesota averages from internal and external research sources.</p>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row example-row">
        <div class="col my-auto text-center">
          <h3>Commission Details</h3>
        </div>
      </div>
      <hr>
      <div class="container">
        <div class="row example-row">
          <div class="col text">
            <h3>HomApt Buyer Agent Commission</h3>
            <p>To be able to share in the HomApt Commission Program, the minimum buyer's agent commission is 1.5% of list price or $7,000
              (whichever is greater). Buyer's agent fee is subject to change. The HomApt Commission Program is currently only available in Minnesota.
            </p>
          </div>
          <div class="col text">
            <h3>HomApt Seller's Agent Commission</h3>
            <p>The HomApt Listing product is 1.5% of sale price or $5,500 (whichever is greater). If buyer is unrepresented, 1% commission may be added to sale
              price. Seller's agent commission is subject to change and does not include the Buyer's agent commission.
            </p>
          </div>
        </div>
      </div>
      <div class="row contact-wrapper">
        <div class="col text-center my-auto">
          <h3>Get a HomApt Agent Today!</h3>
          <router-link to="/contact">
            <button class="btn btn-secondary">Contact Us</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Save Time and Money',
    meta: [
      { vmid: 'description', content: 'Fill in' }
    ]
  },
  computed: {
    backgroundImage () {
      return 'background-image: url("https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xlarge/uploads/DSC_3368_2.jpg")'
    }
  }
}
</script>

<style scoped>
.contact-wrapper {
 height: 200px;
 background-color: #feedaa;
}

.homapt-header {
  height: 50vh !important;
  background-color: rgba(52, 58, 64, .8);
}

.title {
  color: white !important;
}

.example-row {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.price-difference-row {
  background-color: #feedaa;
  margin-bottom: 1rem;
}

.homapt-table {
  border-style: solid;
  border-width: 1px;
  margin-bottom: 2rem;
}

.homapt-table-row {
  border-bottom-style: solid;
  border-width: 1px;
}

.table-text {
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.center-column {
  border-right-style: solid;
  border-left-style: solid;
  border-width: 1px;
}

.table-conclusion {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: white !important;
}

.conclusion {
  background-color: rgba(52, 58, 64, 1);
}

.container-fluid {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/saveTimeMoney/TheSaveTimeMoney.vue